import React from 'react';
import { Image } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LogoWithImageProps {
  className?: string;
  size?: "small" | "default";
  spin?: "clockwise" | "counterclockwise" | false;
  IconComponent?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export function LogoWithImage({ className, size = "default", spin = "clockwise", IconComponent = Image }: LogoWithImageProps) {
  const sizeClass = size === "small" ? "w-8 h-8" : "w-12 h-12";
  const spinClass = spin === "clockwise" ? "animate-[spin_8s_linear_infinite]" : 
                   spin === "counterclockwise" ? "animate-[spin_8s_linear_infinite_reverse]" : "";
  
  return (
    <div className={cn("relative aspect-square", sizeClass, className)}>
      {/* Spinning outer layer */}
      <div className={cn("absolute inset-0 outer-square", spinClass)}>
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="[&_rect]:origin-center"
        >
          <defs>
            <linearGradient id="borderGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="currentColor" />
              <stop offset="100%" stopColor="currentColor" />
            </linearGradient>
          </defs>
          <rect x="0" y="0" width="32" height="32" rx="4" fill="transparent"/>
          <rect x="1" y="1" width="30" height="30" rx="3" stroke="currentColor" strokeWidth="2"/>
        </svg>
      </div>
      
      {/* Static inner circle and image icon */}
      <div className="absolute inset-0">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="12" fill="transparent" stroke="currentColor" strokeWidth="2"/>
          <foreignObject x="7" y="7" width="18" height="18">
            <div className="relative w-full h-full flex items-center justify-center">
              <IconComponent className="w-full h-full [color:currentColor]" />
            </div>
          </foreignObject>
        </svg>
      </div>
    </div>
  );
}
